module.exports = __webpack_public_path__ + "img/touxiang.1a5961e5.png";